import * as actions from './document/actions'
import * as mutations from './document/mutations'
import * as getters from './document/getters'

//import { dataProps } from './document/properties'

const state = {
    props: [],
    deletedItems: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/document.js